import React, { useEffect, useRef, useState } from "react";
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { ButtonStyleAzul, ButtonStyleVerde, ButtonStyleWhite, CssTextField, DivBackgroundDasboard, DivStyleSend, MaxDiv, PaperStyle, TypographyStyleSecundary } from "../../../styles/Styles";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderCustom from "../../../components/header/HeaderCustom";
import NumberFormatCustom from "../../../components/numberCustom/NumberFormatCustom";
import { Box, Typography, Alert, Snackbar } from '@mui/material';
import { AccountBalance, QrCodeScanner, Send } from "@mui/icons-material";
import Lottie from 'lottie-react-web'
import animation from '../../../assets/imgconfirmacion.json'
import animationcheck from '../../../assets/checkmark.json'
import SplashConfirmation from "../../../splash/SplashConfirmation";
import { LogoSicoopFondo } from "../../../components/logos/LogoFondo";
import { exportComponentAsPNG } from "react-component-export-image";
import html2canvas from "html2canvas";
import { ButtonFlotante } from "../../../components/botonQr/ButtonFlotante";


const ConfirmacionPage = () => {
    const [splashState, setSplashState] = useState(true);

    const CompartirRef = useRef();

    let history = useNavigate();

    const { state } = useLocation();

    console.log('confirmacion====>', state);


    useEffect(() => {
        setTimeout(() => {
            setSplashState(false);
        }, 2000);
    }, []);

    //reseterar al inicio, sin poder volver atras
    const handleHomeReset = () => {
        history('/home', { replace: true });
    };

    const handleCaptureMobile = () => {
        html2canvas(CompartirRef.current)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                // console.log("imgData", imgData);
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'share', data: imgData, fileName: 'confirmacion_pago' }));
            })
            .catch((err) => {
                console.log("err", err);
            })
    };

    const downloadPng = async () => {
        await exportComponentAsPNG(CompartirRef, { fileName: 'confirmacion_pago' });
    };


    const handleShare = async () => {

        //enviar el mensaje a la webView de react native, para que se pueda compartir
        if (window.ReactNativeWebView) {//se valida si es una app de react native
            handleCaptureMobile();
        } else {
            console.log("es el navegador web");
            downloadPng();
        }

    }



    if (splashState) {
        return (<SplashConfirmation status={state} />)
    }



    const handleFechaPagos = (item) => {
        let fechaPago = '';
        let validPagos = item && item.pagos && item.pagos.length > 0;


        if (validPagos) {
            fechaPago = item.pagos[0].fechaPago;
        } else {
            // fechaPago = state?.fechaActualizacion;
            //parsear la fecha de ISO 8601 a dd/mm/aaaa 00:00 Hs.
            let fecha = new Date(state?.fechaCreacion);
            let dia = fecha.getDate();
            let mes = fecha.getMonth() + 1;
            let anio = fecha.getFullYear();
            let hora = fecha.getHours();
            let minutos = fecha.getMinutes();

            fechaPago = `${dia < 10 ? '0' + dia : dia}/${mes < 10 ? '0' + mes : mes}/${anio} ${hora < 10 ? '0' + hora : hora}:${minutos < 10 ? '0' + minutos : minutos} Hs.`;
        }

        return fechaPago;
    };

    const handleMontoPagado = (item) => {
        let montoPagado = 0;
        let validPagos = item && item.pagos && item.pagos.length > 0;
        const esSip = state?._esSip === true;

        if (validPagos) {
            montoPagado = item.pagos[0].importe;
            if (esSip) {
                return `Gs. ${Number(montoPagado).toLocaleString('es-PY', { minimumFractionDigits: 0 })}`;
            }
            //ejemplo si es 100, debe de eliminar los decimales==> solo debe quedar el 1 sin los 00
            montoPagado = montoPagado.toString();
            montoPagado = montoPagado.replace('00', '');
            // montoPagado = montoPagado.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            montoPagado = `Gs. ${parseInt(montoPagado).toLocaleString('es-PY', { minimumFractionDigits: 0 })}`

        } else {
            montoPagado = state?.monto;
            montoPagado = montoPagado.toString();
            montoPagado = montoPagado.replace('00', '');
            montoPagado = `Gs. ${parseInt(montoPagado).toLocaleString('es-PY', { minimumFractionDigits: 0 })}`
        }

        return montoPagado;
    };

    const handleIdOperacion = (item) => {
        let idOperacion = '';

        if (state?.idTxDestinatario) {
            return state.idTxDestinatario;
        }

        if (state?.idOperacion) {
            return state.idOperacion;
        }

        let validPagos = item && item.pagos && item.pagos.length > 0;

        if (validPagos) {
            idOperacion = item.pagos[0].idPagoQr;
        }

        return idOperacion;
    };

    const handleEstado = (item) => {
        let status = '';
        let validPagos = item && item.pagos && item.pagos.length > 0;

        if (validPagos) {
            status = item.pagos[0].estado === "Payment" ? "Pagado" : item.pagos[0].estado;
        } else {
            status = state?.estado === "RE" ? "Rechazado" : state?.estado === "AP" ? "Aprobado" : "Pendiente";
        }

        return status;
    };



    return (
        <HeaderCustom title="Sicoop Comercios">
            <MaxDiv>
                <PaperStyle style={{ padding: 0 }}>
                    {state && (
                        <div>
                            <DivStyleSend ref={CompartirRef} style={{ position: 'relative', overflow: 'hidden' }}>
                                <div>
                                    <LogoSicoopFondo tamano={200} />
                                </div>
                                {(state?.data?.estado === "ACEP" || state?.data?.estado === "Payment") && (
                                    <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                        ¡Tu pago fue realizado con éxito!
                                    </TypographyStyleSecundary>
                                )}

                                {state?.estado === "AP" && (
                                    <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                        ¡Tu pago fue realizado con éxito!
                                    </TypographyStyleSecundary>
                                )}

                                {state?.estado === "RE" && (
                                    <Box>
                                        <TypographyStyleSecundary component="h5" variant="h5" align='center'>
                                            ¡Tu pago fue rechazado!
                                        </TypographyStyleSecundary>

                                        <TypographyStyleSecundary gutterBottom variant="subtitle1" align='center'>
                                            Vuelve a intentarlo más tarde, o contacta con nosotros al (021) 729 7777.
                                        </TypographyStyleSecundary>
                                    </Box>

                                )}




                                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                    {state.bancoSeleccionado && (
                                        <ListItemText
                                            primary={
                                                <div style={{}}>
                                                    <Box sx={{}}>
                                                        <Typography
                                                            sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                            component="span"
                                                            variant="subtitle1"
                                                        >
                                                            {state.bancoSeleccionado ? state.bancoSeleccionado.label : ''}
                                                        </Typography>
                                                    </Box>
                                                </div>
                                            }
                                            secondary={
                                                <div style={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', wordBreak: 'break-word' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        {state ? state.cuentaAcreditar : ''}
                                                    </Typography>
                                                </div>
                                            }
                                        />
                                    )}

                                    {state.documentoTitular && (
                                        <ListItemText
                                            primary={
                                                <div style={{}}>
                                                    <Box sx={{}}>
                                                        <Typography
                                                            sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                            component="span"
                                                            variant="subtitle1"
                                                        >
                                                            {state ? state.userTitular : ''}
                                                        </Typography>
                                                    </Box>
                                                </div>
                                            }
                                            secondary={
                                                <div style={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', wordBreak: 'break-word' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        C.I: {state ? state.documentoTitular : ''}
                                                    </Typography>
                                                </div>
                                            }
                                        />
                                    )}

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Box sx={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        Nro. de operación
                                                    </Typography>
                                                </Box>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline', wordBreak: 'break-all' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {handleIdOperacion(state.data)}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Box sx={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        Estado
                                                    </Typography>
                                                </Box>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {handleEstado(state.data)}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Box sx={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        Fecha
                                                    </Typography>
                                                </Box>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {/* {state.fecha ? state.fecha : 'dd/mm/aaaa 00:00 Hs.'} */}
                                                    {handleFechaPagos(state.data)}
                                                </Typography>
                                            </div>
                                        }
                                    />

                                    <ListItemText
                                        primary={
                                            <div style={{}}>
                                                <Box sx={{}}>
                                                    <Typography
                                                        sx={{ display: 'inline', fontSize: '1rem', width: '50%' }}
                                                        component="span"
                                                        variant="subtitle1"
                                                    >
                                                        Monto pagado
                                                    </Typography>
                                                </Box>
                                            </div>
                                        }
                                        secondary={
                                            <div style={{}}>
                                                <Typography
                                                    sx={{ display: 'inline' }}
                                                    component="span"
                                                    variant="subtitle1"
                                                >
                                                    {/* {`Gs. ${parseInt(state ? state.monto : '0').toLocaleString('es-PY', { minimumFractionDigits: 0 })}`} */}
                                                    {handleMontoPagado(state.data)}
                                                </Typography>
                                            </div>
                                        }
                                    />
                                </List>
                            </DivStyleSend>




                            <DivStyleSend>
                                <div style={{}}>
                                    <ButtonStyleAzul
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px'
                                        }}
                                        startIcon={<QrCodeScanner />}
                                        onClick={handleHomeReset}
                                    >
                                        Generar SIcoop QR
                                    </ButtonStyleAzul>
                                </div>

                                <div style={{}}>
                                    <ButtonStyleWhite
                                        variant="contained"
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            borderRadius: '10px',
                                            color: '#333',
                                            fontSize: '12px'
                                        }}
                                        startIcon={<Send />}
                                        onClick={handleShare}
                                    >
                                        Compartir
                                    </ButtonStyleWhite>
                                </div>
                            </DivStyleSend>



                        </div>
                    )}

                </PaperStyle>

                 {/*agregar boton flotante*/}
                 <ButtonFlotante />
            </MaxDiv>
        </HeaderCustom>
    )
}

export default ConfirmacionPage;